import { Trophy, Crown, Medal, Award } from "lucide-react";
import { resolveImage } from "@/lib/api";

const styles = {
  1: { ring: "ring-gold", badge: "gold-gradient text-obsidian", Icon: Crown, order: "order-1 sm:order-2", size: "h-28 w-28 sm:h-32 sm:w-32", label: "1st" },
  2: { ring: "ring-slate-300/60", badge: "bg-slate-300 text-obsidian", Icon: Medal, order: "order-2 sm:order-1", size: "h-24 w-24", label: "2nd" },
  3: { ring: "ring-amber-700/70", badge: "bg-amber-700 text-white", Icon: Award, order: "order-3 sm:order-3", size: "h-24 w-24", label: "3rd" },
};

function PodiumCard({ agency }) {
  const st = styles[agency.position] || styles[3];
  const Icon = st.Icon;
  return (
    <div className={`card-surface flex flex-col items-center rounded-2xl p-6 text-center ${st.order} ${agency.position === 1 ? "sm:-mt-6 gold-glow" : ""}`}
      data-testid={`agency-podium-${agency.position}`}>
      <div className={`relative overflow-hidden rounded-full ring-4 ${st.ring} ${st.size}`}>
        {agency.image_url ? (
          <img src={resolveImage(agency.image_url)} alt={agency.name} className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-obsidian-elevated">
            <Trophy className="h-10 w-10 text-gold/60" />
          </div>
        )}
      </div>
      <span className={`mt-4 inline-flex items-center gap-1.5 rounded-full px-4 py-1 text-sm font-bold ${st.badge}`}>
        <Icon className="h-4 w-4" /> #{agency.position} · {st.label}
      </span>
      <h3 className="mt-3 text-lg font-bold text-slate-100 sm:text-xl">{agency.name || "—"}</h3>
      {agency.agency_id && <p className="mt-1 font-mono text-xs text-gold">ID: {agency.agency_id}</p>}
    </div>
  );
}

export function AgencyPodium({ agencies }) {
  const sorted = [...agencies].sort((a, b) => a.position - b.position);
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-3 sm:items-end" data-testid="agency-podium">
      {sorted.map((a) => <PodiumCard key={a.position} agency={a} />)}
    </div>
  );
}
